import { PageRoute } from '../components/Page';

import Neuron from './Neuron';
import StoreGroup from './StoreGroup';
import NightWatch from './NightWatch';
import GroupSetting from './GroupSetting';

const childRoutes: PageRoute[] = [
  {
    path: 'officialScenario',
    redirect: true,
    element: <Neuron path="qa/scenarios/packages" />,
    i18nHelmetTitle: 'aide.官方场景',
  },
  {
    path: 'shopScenario',
    element: <Neuron path="qa/scenarios/combine" />,
    i18nHelmetTitle: 'aide.店铺场景',
  },
  {
    path: 'chartsScenario',
    element: <Neuron path="qa/scenarios/charts" />,
    i18nHelmetTitle: 'aide.尺码推荐场景',
    access: ({ orgConfig: { qaItemEnable } }) => (qaItemEnable ? 'write' : false),
  },
  {
    path: 'item',
    element: <Neuron path="qa/items/settings" />,
    i18nHelmetTitle: 'aide.商品配置',
    access: ({ orgConfig: { qaItemEnable } }) => (qaItemEnable ? 'write' : false),
  },
  {
    path: 'itemsChart',
    element: <Neuron path="qa/items/charts" />,
    i18nHelmetTitle: 'aide.版型管理',
    access: ({ orgConfig: { qaItemEnable } }) => (qaItemEnable ? 'write' : false),
  },
  {
    path: 'storeGroup',
    element: <StoreGroup />,
    i18nHelmetTitle: 'storeGroup.店铺配置组',
  },
  {
    path: 'nightWatch',
    element: <NightWatch />,
    i18nHelmetTitle: 'aide.值守设置',
  },
  {
    path: 'groupSetting',
    element: <GroupSetting />,
    i18nHelmetTitle: 'aide.配置组规则',
  },
];

export const noNeedQueryPathList = ['globalSettings'];

export default childRoutes;
